import { render, staticRenderFns } from "./Narxnoma.vue?vue&type=template&id=262b2107&scoped=true"
import script from "./Narxnoma.vue?vue&type=script&lang=js"
export * from "./Narxnoma.vue?vue&type=script&lang=js"
import style0 from "./Narxnoma.vue?vue&type=style&index=0&id=262b2107&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262b2107",
  null
  
)

export default component.exports